import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IDialogMessage } from 'src/app/@amiga-pyme/components/ami-dialog-message/ami-dialog-message.interface';
import { CrudService } from 'src/app/@amiga-pyme/services/crud.service';

@Component({
  template: ''
})
export class CreateTemplate {
  open = true;
  @Output() close = new EventEmitter<boolean>();
  message: IDialogMessage;
  fg: FormGroup;
  constructor(
    @Inject(String) private name: string,
    private service: CrudService
  ) {}

  async createItem$(item) {
    this.message = { message: `Registrando ${this.name}` };
    this.message = await this.service.register(item);
    const status = this.message.status;
    if (200 <= status && status < 300) {
      this.service.getData$();
      setTimeout(() => {
        this.onClose();
      }, 1500);
    }
  }

  onClose() {
    this.close.emit();
  }
}
